import template from './mx-shell-navigation-panel.html';
import { EventCodes } from '../../../../App/model/event-codes';

/**
 * @ngdoc component
 * @name mx.shell:mxShellNav
 * @module mx.shell
 * @requires <a href="https://docs.angularjs.org/api/ng/service/$document" target="_blank">$document</a>
 * @requires <a href="https://docs.angularjs.org/api/ng/service/$timeout" target="_blank">$timeout</a>
 * @requires <a href="https://material.angularjs.org/latest/api/service/$mdSidenav" target="_blank">$mdSidenav</a>
 * @requires {@ref mx.internationalization mx.internationalization}
 * @requires {@ref mx.shell.NavigationService mx.shell.NavigationService}
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 * @requires {@ref mx.shell.NavigationManager mx.shell.NavigationManager}
 * @requires {@ref mx.shell.Config mx.shell.Config}
 * @description
 * Side panel that contains navigation items
 * @usage <mx-shell-nav layout="column"></mx-shell-nav>
 */

export const mxShellNavigationPanelComponent = {
	bindings: {
		favouriteMode: '<',
	},
	controller: MxShellNavigationPanelCtrl,
	controllerAs: 'vm',
	template,
};

MxShellNavigationPanelCtrl.$inject = [
	'mx.internationalization',
	'mx.shell.NavigationService',
	'mx.shell.EventService',
	'mx.shell.NavigationManager',
	'mx.shell.LeftSidebarService',
	'$scope',
	'$element',
	'$mdConstant',
	'$document',
];

function MxShellNavigationPanelCtrl(i18n, navigationService, eventService, navigationManager, leftSidebarService, $scope, $element, $mdConstant, $document) {
	const vm = this;

	vm.NavigationManager = navigationManager;
	vm.navigationService = navigationService;
	vm.changeFilterText = changeFilterText;

	const _settingsLabel = i18n.get('shell.common.settings').toLowerCase();
	vm.isSettingLabelVisible = (searchText) => !searchText || _settingsLabel.includes(searchText.toLowerCase());

	eventService.subscribeTo(
		mx.shell.EventCodes.NavigationLoaded,
		(event, { navItems }) => {
			init(navItems);
		},
		$scope
	);

	vm.$onInit = () => {
		vm.isVisible = true;
		navigationService.get().then((navItems) => {
			vm.isNavLoaded = true;
			init(navItems);
			initKeyboardControl();
		});
	};

	vm.favoriteFilter = ({ showInFavorite }) => {
		if (vm.favouriteMode) {
			return showInFavorite;
		}
		return true;
	};

	return vm;

	function init(navItems) {
		vm.configurationModeOn = false;

		vm.navItems = navItems;
		// navigationManager.__navItemsModel = vm.navItems;

		if (Array.isArray(navItems) && navItems.length) {
			leftSidebarService.enablePanel('navigation');
		} else {
			leftSidebarService.disablePanel('navigation');
		}
	}

	function changeFilterText(filterText) {
		const oldFilterText = vm.NavigationManager.filterText;

		if (filterText || (oldFilterText && !filterText)) {
			navigationService.markFilterTextMatched(vm.navItems, filterText.toLowerCase(), undefined, (filterText || '').length > (oldFilterText || '').length);
			vm.NavigationManager.filterText = filterText;

			eventService.dispatchEvent(EventCodes.TrackTelemetry, {
				eventName: 'Search in Navigation executed',
			});
		}
	}

	function initKeyboardControl() {
		let allNavItems;

		$element.keydown(({ keyCode }) => {
			const activeEl = $($document[0].activeElement);
			if (activeEl.is('.mx-shell-nav-item--btn')) {
				if (keyCode === $mdConstant.KEY_CODE.ESCAPE) {
					activeEl.blur();
				}

				if (keyCode === $mdConstant.KEY_CODE.DOWN_ARROW) {
					_getClosestSibling(activeEl, true).focus();
				}

				if (keyCode === $mdConstant.KEY_CODE.UP_ARROW) {
					_getClosestSibling(activeEl, false).focus();
				}
			}
		});

		eventService.subscribeTo(
			mx.shell.EventCodes.NavigationItemClicked,
			() => {
				allNavItems = undefined;
			},
			$scope
		);

		function _getClosestSibling(activeEl, downOtherwiseUp) {
			let res = activeEl;
			allNavItems = allNavItems || $element.find('.mx-shell-nav-item--btn');
			const currentNavItemIndex = allNavItems.index(activeEl);
			if (downOtherwiseUp && currentNavItemIndex !== -1 && currentNavItemIndex + 1 < allNavItems.length) {
				res = $(allNavItems[currentNavItemIndex + 1]);
			} else if (!downOtherwiseUp && currentNavItemIndex > 0) {
				res = $(allNavItems[currentNavItemIndex - 1]);
			}
			return res;
		}
	}
}
